
    <!--
 * 电脑端-背景音乐
 * @LastEditTime: Thu Sep 19 2024 16:44:01 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_WD0A18"  :class="[`normal`,`u_c_WD0A18`]" ><audio id="u_c_YOIC19" type="audio/mpeg" loop="true" :autoplay="!compData.isEdit" :class="[`normal bgm`,`u_c_YOIC19`]" ><source id="u_c_AB1620"  :src="compData.bgm" :class="[`normal`,`u_c_AB1620`]" /></audio><div id="u_c_37X621"  :class="[compData.bgmState ? '' : 'mute',`normal`,`u_c_37X621`]" @click="u_c_37X621_event_62O323($event)"></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"bgm":`https://d2ex983vwhbc52.cloudfront.net/auto_system_upload/2024/09/1726230232605-6.mp3`,"isEdit":true,"bgmState":true},"en-US":{"bgm":`https://d2ex983vwhbc52.cloudfront.net/auto_system_upload/2024/09/1726230232605-6.mp3`,"isEdit":true,"bgmState":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    compData.isEdit = false;

onMounted(() => {
  compData.bgmState = false;
  let audioEle = document.querySelector(".bgm");
  if (!audioEle) return
  if (audioEle.paused) {
    compData.bgmState = !audioEle.paused
  }
  audioEle.addEventListener("playing", () => {
    compData.bgmState = true
  }, true);
  audioEle.addEventListener("pause", () => {
    compData.bgmState = false
  }, true)
})

// 定义一个函数来添加事件监听器
function addEventListeners() {
  // 获取整个文档
  const element = document.documentElement;

  // 定义一个事件处理函数
  function handleEvent(event) {
    let audioEle = document.querySelector(".bgm");
    if (!audioEle) return
    if (audioEle.paused) {
      audioEle.play();
    }

    // 注销所有事件监听器
    element.removeEventListener('click', handleEvent);
    element.removeEventListener('touchstart', handleEvent);
    element.removeEventListener('keydown', handleEvent);
  }

  // 添加各种事件监听器
  element.addEventListener('click', handleEvent);
  element.addEventListener('touchstart', handleEvent); // 移动端触摸事件
  element.addEventListener('keydown', handleEvent);

}

// 初始化时添加事件监听器
addEventListeners();;
      // 喇叭的click事件
      const u_c_37X621_event_62O323= async (e)=>{
        try {  let audioEle = document.querySelector(".bgm");
  if (!audioEle) return
  if (compData.bgmState) {
    audioEle.pause()
  } else {
    audioEle.play()
  }} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_WD0A18.normal{
position:absolute;
top:2.22vh;
left:50%;
transform:translateX(-50%);
margin-left:81.76vh;

}
}.default{
.u_c_YOIC19.normal{
position:relative;

}
}.default{
.u_c_AB1620.normal{
position:relative;

}
}.default{
.u_c_37X621.normal{
position:relative;
width:5.93vh;
height:5.93vh;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726626152453-43.png);
cursor:pointer;

}

.u_c_37X621.normal.mute{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726626356998-41.png);

}
}.en-US{
.u_c_WD0A18.normal{
position:absolute;
top:2.22vh;
left:50%;
transform:translateX(-50%);
margin-left:81.76vh;

}
}.en-US{
.u_c_YOIC19.normal{
position:relative;

}
}.en-US{
.u_c_AB1620.normal{
position:relative;

}
}.en-US{
.u_c_37X621.normal{
position:relative;
width:5.93vh;
height:5.93vh;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726626152453-43.png);
cursor:pointer;

}

.u_c_37X621.normal.mute{
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726626356998-41.png);

}
}
</style>
